import { Ref, ref } from 'vue'

export type BrowserType = 'opera' | 'edge' | 'chrome' | 'safari' | 'firefox' | 'IE' | 'unknown'

export function checkBrowserType (): {userBrowser: Ref<BrowserType>} {
  const userBrowser: Ref<BrowserType> = ref('unknown')

  if (navigator.userAgent.indexOf('Opera') !== -1 || navigator.userAgent.indexOf('OPR') !== -1) {
    userBrowser.value = 'opera'
  } else if (navigator.userAgent.indexOf('Edg') !== -1) {
    userBrowser.value = 'edge'
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    userBrowser.value = 'chrome'
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    userBrowser.value = 'safari'
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    userBrowser.value = 'firefox'
  } else if (navigator.userAgent.indexOf('MSIE') !== -1) {
    userBrowser.value = 'IE'
  } else {
    userBrowser.value = 'unknown'
  }

  return {
    userBrowser,
  }
}
